// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.search_field {
  width: 70%;
  height: 28px;
  padding-left: 2%;
  float: left;
}

.search_field::placeholder {
  font-size: 14px !important;
}

.mat-expansion-panel-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0;
  border-radius: inherit;
}

/* Restored original compact row height (as before / image 2). */
::ng-deep.list_accordion .mat-expansion-panel-header {
  height: 0px !important;
}

/* Single-line RuleName without widening the modal: title uses leftover row space; controls stay content-sized.
   Material 16 renders mat-panel-title as .mat-expansion-panel-header-title (not .mat-panel-title). */
::ng-deep.list_accordion .mat-expansion-panel-header .mat-content {
  align-items: center;
}

::ng-deep.list_accordion .mat-expansion-panel-header-title {
  flex: 1 1 auto !important;
  max-width: none !important;
  overflow: hidden;
}

::ng-deep.list_accordion .mat-expansion-panel-header-description {
  /* Material default flex-grow: 2 left a large empty gap before Test Mode / toggle / Edit */
  flex: 0 0 auto !important;
  width: auto !important;
  margin-right: 8px;
  justify-content: flex-end;
}

::ng-deep.list_accordion .mat-expansion-panel-header-title .d-flex,
::ng-deep.list_accordion .mat-expansion-panel-header-title strong {
  white-space: nowrap;
}

::ng-deep.mat-expansion-indicator {
  position: relative !important;
  right: 1% !important;
  top: -4px !important;
}

.filter_icon {
  position: relative;
  top: 7%;
}

.label_style {
  display: block;
  margin-block: 1%;
  font-size: 12px !important;
  overflow-y: auto !important;
}

.search_control_w700 {
  height: 30px !important;
  font-size: 12px !important;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  border-radius: 5px;
  overflow-y: auto !important;
}

.search_control_w700_input {
  height: 30px !important;
  font-size: 12px !important;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  border-radius: 5px;
  overflow-y: auto !important;
}

input::placeholder {
  color: #797676 !important;
}

.w700_text {
  font-size: 12px !important !important;
}

.varule-controls-wrap {
  float: right;
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  right: 3%;
  top: 0px;
  color: white;
}

.varule-toggle-anchor {
  display: inline-flex;
  align-items: center;
}

.varule-edit-btn {
  background-color: rgb(23, 162, 184);
  color: white;
  border-radius: 4px;
  padding-inline: 1%;
  font-size: 15px;
  margin: 3px;
  border: none;
  width: 35px;
}

.varule-reference-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10049;
  background-color: rgba(0, 0, 0, 0.35);
  pointer-events: auto;
}

.varule-reference-fixed-panel {
  position: fixed;
  z-index: 10050;
  width: 335px;
  max-width: 600px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
  padding: 8px 12px 4px;
}

.varule-reference-field {
  width: 100%;
}

.varule-reference-actions {
  display: flex;
  justify-content: flex-end;
  gap: 4px;
  padding-bottom: 4px;
}

.disable-backdrop-click .cdk-overlay-backdrop.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing {
  pointer-events: none;
}

::ng-deep.autocomplete-container .suggestions-container.is-visible {
  z-index: 999 !important;
}

::ng-deep.autocomplete-container .suggestions-container {
  position: absolute;
  width: 100%;
  background: #fff;
  height: auto;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
}

::ng-deep.autocomplete-container .suggestions-container.is-visible {
  visibility: visible;
}

::ng-deep.autocomplete-container .suggestions-container.is-visible {
  z-index: 999 !important;
}

/* Scoped to VA Rules chip multiselect options only (.varules-multiselect-option) — avoids affecting other screens using .compendium_cast */
.compendium_cast.varules-multiselect-option {
  font-family: Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  height: 30px !important;
}
.compendium_cast.varules-multiselect-option .multiselect-suggestion-row {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
}
.compendium_cast.varules-multiselect-option .varules-ms-chosen-mark {
  flex-shrink: 0;
  min-width: 1.1em;
  margin-right: 4px;
  font-weight: 700;
  font-size: 12px;
  line-height: 1;
}
.compendium_cast.varules-multiselect-option .multiselect-suggestion-em {
  font-weight: 700 !important;
  font-style: normal !important;
}

/* Panel is in CDK overlay — pierce encapsulation; selector includes .varules-multiselect-option so Compendium/Homepage .compendium_cast options are untouched */
::ng-deep .cdk-overlay-container .mat-mdc-option.varules-multiselect-option .multiselect-suggestion-em {
  font-weight: 700 !important;
  font-family: Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif !important;
}

::ng-deep .cdk-overlay-container .mat-mdc-option.varules-multiselect-option .mdc-list-item__primary-text strong.multiselect-suggestion-em {
  font-weight: 700 !important;
  font-family: Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif !important;
}

::ng-deep .cdk-overlay-container .mat-mdc-option.varules-multiselect-option.compendium_cast .mdc-list-item__primary-text {
  font-family: Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif !important;
}

/* ADDITIVE: chip mat-autocomplete (Case Status + API chip multiselects e.g. Excluded OF Accounts) — scrollable panel; host uses \`[class]\` (not panelClass) so overlay gets this class; pane z-index above ngx .autocomplete-container.active (10001) in this file. */
::ng-deep body .cdk-overlay-pane:has(.varules-chip-mat-scroll-panel) {
  z-index: 10100 !important;
}

::ng-deep .cdk-overlay-container .mat-mdc-autocomplete-panel.varules-chip-mat-scroll-panel {
  max-height: min(50vh, 320px) !important;
  min-height: 0 !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  pointer-events: auto !important;
  touch-action: auto !important;
}

::ng-deep .cdk-overlay-container .mat-mdc-autocomplete-panel.varules-chip-mat-scroll-panel.mdc-menu-surface {
  min-height: 0 !important;
  overflow-y: auto !important;
}

/* Case Status chip panel only: label + ✓ on the right; chosen rows stay visible with teal text/bg (full list or filtered). */
/* was: ✓ color #17a2b8, margin-right 6px — not flush to row edge, not purple. */
::ng-deep .cdk-overlay-container .mat-mdc-autocomplete-panel.varules-casestatus-only-chip-panel {
  /* Let the custom row span the option’s content width so ✓ can sit at the trailing edge. */
  /* was: color #7b1fa2 without !important — MDC / theme could still paint the ✓ like body text. */
}
::ng-deep .cdk-overlay-container .mat-mdc-autocomplete-panel.varules-casestatus-only-chip-panel .mat-mdc-option.compendium_cast.varules-multiselect-option .mat-mdc-option-text,
::ng-deep .cdk-overlay-container .mat-mdc-autocomplete-panel.varules-casestatus-only-chip-panel .mat-mdc-option.compendium_cast.varules-multiselect-option .mdc-list-item__primary-text {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}
::ng-deep .cdk-overlay-container .mat-mdc-autocomplete-panel.varules-casestatus-only-chip-panel .varules-case-status-suggestion-row.multiselect-suggestion-row {
  display: flex;
  width: 100%;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
}
::ng-deep .cdk-overlay-container .mat-mdc-autocomplete-panel.varules-casestatus-only-chip-panel .varules-case-status-suggestion-row .multiselect-suggestion-label {
  flex: 1 1 auto;
  min-width: 0;
  padding-right: 4px;
}
::ng-deep .cdk-overlay-container .mat-mdc-autocomplete-panel.varules-casestatus-only-chip-panel .varules-case-status-suggestion-row .varules-ms-chosen-mark--casestatus-end {
  flex: 0 0 auto;
  margin-left: auto;
  /* was: margin-right 0 — align ✓ with the visual right edge of the list row (MDC option padding). */
  margin-right: -10px;
  padding-right: 12px;
  min-width: 1.1em;
  text-align: right;
  font-weight: 700;
  font-size: 14px;
  line-height: 1;
  color: #9c27b0 !important;
  -webkit-text-fill-color: #9c27b0 !important;
}
::ng-deep .cdk-overlay-container .mat-mdc-autocomplete-panel.varules-casestatus-only-chip-panel .mat-mdc-option.varules-case-status-option-chosen .varules-ms-chosen-mark--casestatus-end {
  color: #9c27b0 !important;
  -webkit-text-fill-color: #9c27b0 !important;
}
::ng-deep .cdk-overlay-container .mat-mdc-autocomplete-panel.varules-casestatus-only-chip-panel .mat-mdc-option.varules-case-status-option-chosen {
  background-color: rgba(23, 162, 184, 0.14) !important;
}
::ng-deep .cdk-overlay-container .mat-mdc-autocomplete-panel.varules-casestatus-only-chip-panel .mat-mdc-option.varules-case-status-option-chosen.mat-mdc-option-active {
  background-color: rgba(23, 162, 184, 0.22) !important;
}
::ng-deep .cdk-overlay-container .mat-mdc-autocomplete-panel.varules-casestatus-only-chip-panel .mat-mdc-option.varules-case-status-option-chosen .multiselect-suggestion-label,
::ng-deep .cdk-overlay-container .mat-mdc-autocomplete-panel.varules-casestatus-only-chip-panel .mat-mdc-option.varules-case-status-option-chosen .multiselect-suggestion-label strong.multiselect-suggestion-em {
  color: #0f6674 !important;
  font-weight: 600 !important;
}

/* Case Status + empty filter: was blanket black on all options — hid chosen highlight. Now only strip stray MDC accent on rows that are not chip-chosen. */
/* was:
::ng-deep .cdk-overlay-container .mat-mdc-autocomplete-panel.varules-casestatus-only-chip-panel.varules-casestatus-autocomplete-empty-query {
  .mat-mdc-option,
  .mat-mdc-option .mdc-list-item__primary-text,
  ...
}
*/
::ng-deep .cdk-overlay-container .mat-mdc-autocomplete-panel.varules-casestatus-only-chip-panel.varules-casestatus-autocomplete-empty-query {
  --mat-option-selected-state-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-option-selected-state-layer-color: transparent;
  --mat-full-pseudo-checkbox-selected-icon-color: rgba(0, 0, 0, 0.54);
}
::ng-deep .cdk-overlay-container .mat-mdc-autocomplete-panel.varules-casestatus-only-chip-panel.varules-casestatus-autocomplete-empty-query .mat-mdc-option:not(.varules-case-status-option-chosen).mat-mdc-option-active .mdc-list-item__primary-text,
::ng-deep .cdk-overlay-container .mat-mdc-autocomplete-panel.varules-casestatus-only-chip-panel.varules-casestatus-autocomplete-empty-query .mat-mdc-option:not(.varules-case-status-option-chosen).mdc-list-item--selected .mdc-list-item__primary-text {
  color: rgba(0, 0, 0, 0.87) !important;
}

/* ngx-auto-complete dropdown (LabUIControls / Lab Integration / Additional data): scroll suggestions */
/* .autocomplete-container .suggestions-container — height: auto only; limit height so wheel/touch scroll works */
::ng-deep .varules-ng-autocomplete-options-scroll .autocomplete-container .suggestions-container {
  max-height: min(50vh, 320px) !important;
  overflow-y: auto !important;
  overscroll-behavior: contain;
  pointer-events: auto !important;
  touch-action: pan-y !important;
}

/* ngx-autocomplete often scrolls the inner ul; modal stacking can trap/hide dropdown — explicit ul scroll + z-index */
::ng-deep .varules-ng-autocomplete-options-scroll .autocomplete-container .suggestions-container ul {
  max-height: min(45vh, 260px) !important;
  overflow-y: auto !important;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-y !important;
  overscroll-behavior: contain;
}

::ng-deep .varules-ng-autocomplete-options-scroll .autocomplete-container.active {
  z-index: 10001 !important;
}

/* Bootstrap modal (~1050) is above default CDK overlay (~1000) — MatAutocomplete panel could not receive wheel events */
::ng-deep body .cdk-overlay-container {
  z-index: 1060 !important;
}

::ng-deep.compendium_casetype .mat-standard-chip {
  font-size: 11px;
  margin: 0px;
  height: 23px;
  padding-inline: 5px;
  min-height: unset;
}

::ng-deep.compendium_casetype .mat-form-field-wrapper {
  padding: 0px !important;
}

::ng-deep.compendium_casetype .mat-form-field-infix {
  padding: 4px !important;
  padding-bottom: 6px !important;
  padding-top: 0px !important;
}

.chipinput {
  height: 16px;
  font-size: 11px !important;
  box-sizing: border-box !important;
  border: none !important;
  box-shadow: none !important;
  outline: 0 !important;
  background-color: #fff !important;
  color: rgba(0, 0, 0, 0.87) !important;
}

.checkbox {
  position: relative;
  top: 40%;
}

.mat-form-field {
  position: relative !important;
  text-align: left !important;
  display: block !important;
  border-radius: 5px !important;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
}

::ng-deep.varules .mat-form-field-appearance-outline .mat-form-field-flex {
  padding: 0%;
}

.varule_textarea {
  font-size: 12px !important;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
}

.addvarule {
  width: 50%;
  background-color: white;
  text-align: center;
  position: relative;
  top: 10%;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  float: right;
  height: 29px;
}

.addvarulebtn {
  font-size: 12px !important;
  height: 28px !important;
  line-height: 20px;
  right: 1%;
  top: 0%;
}

.ellipsisfull {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* width: 100% !important; */
  max-width: 90%;
}

::ng-deep.varules .row {
  display: contents !important;
  flex-wrap: unset;
  margin-right: -15px;
  margin-left: -15px;
}

::ng-deep.list_accordion .row {
  display: flex !important;
  flex-wrap: unset;
  margin-right: -15px;
  margin-left: -15px;
  font-size: 12px;
}

::ng-deep.testmodecheckbox .mdc-checkbox {
  padding-right: 3px !important;
  bottom: 3px !important;
}

.text-ellipsis {
  white-space: nowrap !important;
  width: 40% !important;
  text-overflow: ellipsis !important;
  overflow: hidden !important;
}

::ng-deep.varulecheckox.mat-mdc-checkbox {
  width: 100% !important;
}
::ng-deep.varulecheckox.mat-mdc-checkbox .mdc-form-field {
  width: 100% !important;
}
::ng-deep.varulecheckox.mat-mdc-checkbox .mdc-form-field .mdc-label {
  margin-bottom: 0 !important;
  width: 100%;
}
::ng-deep.varulecheckox.mat-mdc-checkbox .mdc-checkbox {
  width: 16px;
  height: 16px;
}
::ng-deep.varulecheckox.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background {
  border-color: #17a0b4 !important;
  background-color: #17a0b4 !important;
}
::ng-deep.varulecheckox.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled ~ .mdc-checkbox__background .mdc-checkbox__checkmark {
  color: white;
}
::ng-deep.varulecheckox.mat-mdc-checkbox .mdc-checkbox__background {
  height: 16px !important;
  width: 16px !important;
}

/* Test Mode checkbox: strip shadow/ripple halo (used with .varulecheckox) */
::ng-deep.test-mode-checkbox-no-shadow.mat-mdc-checkbox {
  box-shadow: none !important;
}
::ng-deep.test-mode-checkbox-no-shadow.mat-mdc-checkbox .mdc-checkbox {
  box-shadow: none !important;
}
::ng-deep.test-mode-checkbox-no-shadow.mat-mdc-checkbox .mdc-checkbox__ripple {
  opacity: 0 !important;
  pointer-events: none !important;
}
::ng-deep.test-mode-checkbox-no-shadow.mat-mdc-checkbox .mat-mdc-checkbox-touch-target {
  box-shadow: none !important;
}
::ng-deep.test-mode-checkbox-no-shadow.mat-mdc-checkbox .mat-focus-indicator::before {
  box-shadow: none !important;
}
::ng-deep.test-mode-checkbox-no-shadow.mat-mdc-checkbox .mdc-checkbox__native-control:focus-visible ~ .mdc-checkbox__ripple {
  opacity: 0 !important;
}

.borderstyles {
  border: transparent !important;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
}

:ng-deep.mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}

::ng-deep.myCustomModalClassaddvarule .modal-dialog {
  max-width: 97%;
  max-height: 60%;
  height: 60%;
  margin: auto;
  padding: 0 !important;
}

::ng-deep.matchipstyles .mat-mdc-chip-row {
  max-width: 20vw !important;
  overflow: hidden;
}
::ng-deep.matchipstyles .mat-mdc-chip-row .mdc-evolution-chip__text-label {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}
::ng-deep.matchipstyles .mat-mdc-chip-row > span:not(mat-icon) {
  max-width: calc(100% - 24px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}

/* REVERTED: inner scroll wrapper (.varules-edit-modal-body / .varules-edit-modal-body-scroll) — HTML reverted to single modal-body overflow-y:auto */
/*
::ng-deep .myCustomModalClassaddvarule .modal-body.varules-edit-modal-body {
  overflow: visible !important;
}
.varules-edit-modal-body-scroll {
  max-height: min(calc(100vh - 220px), 720px);
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
}
*/`, "",{"version":3,"sources":["webpack://./src/app/varules/varules.component.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,UAAA;EACA,YAAA;EAAc,gBAAA;EACd,WAAA;AAEF;;AACA;EACE,0BAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,UAAA;EACA,sBAAA;AAEF;;AAAA,gEAAA;AACA;EACE,sBAAA;AAGF;;AAAA;qGAAA;AAEA;EACE,mBAAA;AAGF;;AADA;EACE,yBAAA;EACA,0BAAA;EACA,gBAAA;AAIF;;AAFA;EACE,0FAAA;EACA,yBAAA;EACA,sBAAA;EACA,iBAAA;EACA,yBAAA;AAKF;;AAHA;;EAEE,mBAAA;AAMF;;AAHA;EACE,6BAAA;EACA,oBAAA;EACA,oBAAA;AAMF;;AAHA;EACE,kBAAA;EAAmB,OAAA;AAOrB;;AAJA;EACE,cAAA;EACA,gBAAA;EACA,0BCzDS;ED0DT,2BAAA;AAOF;;AAJA;EACE,uBC3DW;ED4DX,0BC/DS;EDgET,oDAAA;EACA,kBAAA;EACA,2BAAA;AAOF;;AAJA;EACE,uBCnEW;EDoEX,0BCvES;EDwET,oDAAA;EACA,kBAAA;EACA,2BAAA;AAOF;;AACA;EACE,yBAAA;AAEF;;AAAA;EACE,qCAAA;AAGF;;AADA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;AAIF;;AADA;EACE,oBAAA;EACA,mBAAA;AAIF;;AADA;EACE,mCAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AAIF;;AADA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,qCAAA;EACA,oBAAA;AAIF;;AADA;EACE,eAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,0CAAA;EACA,qBAAA;AAIF;;AADA;EACE,WAAA;AAIF;;AADA;EACE,aAAA;EACA,yBAAA;EACA,QAAA;EACA,mBAAA;AAIF;;AADA;EACE,oBAAA;AAIF;;AAFA;EACE,uBAAA;AAKF;;AAHA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,yCAAA;EACA,sBAAA;AAMF;;AAHA;EACE,mBAAA;AAMF;;AAHA;EACE,uBAAA;AAMF;;AAFA,2IAAA;AACA;EACE,8EAAA;EACA,uBAAA;AAKF;AAHE;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;AAKJ;AAFE;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAIJ;AADE;EACE,2BAAA;EACA,6BAAA;AAGJ;;AACA,gKAAA;AACA;EACE,2BAAA;EACA,8EAAA;AAEF;;AAAA;EACE,2BAAA;EACA,8EAAA;AAGF;;AADA;EACE,8EAAA;AAIF;;AADA,qQAAA;AACA;EACE,yBAAA;AAIF;;AADA;EACE,uCAAA;EACA,wBAAA;EACA,2BAAA;EACA,6BAAA;EACA,+BAAA;EACA,6BAAA;AAIF;;AADA;EACE,wBAAA;EACA,2BAAA;AAIF;;AADA,6HAAA;AACA,gFAAA;AACA;EACE,0FAAA;EAuBA,gGAAA;AAlBF;AAJE;;EAEE,WAAA;EACA,eAAA;EACA,sBAAA;AAMJ;AAHE;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;AAKJ;AAFE;EACE,cAAA;EACA,YAAA;EACA,kBAAA;AAIJ;AAAE;EACE,cAAA;EACA,iBAAA;EACA,mGAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;EACA,2CAAA;AAEJ;AACE;EACE,yBAAA;EACA,2CAAA;AACJ;AAEE;EACE,qDAAA;AAAJ;AAGE;EACE,qDAAA;AADJ;AAIE;;EAEE,yBAAA;EACA,2BAAA;AAFJ;;AAMA,2JAAA;AACA;;;;;;CAAA;AAOA;EACE,iEAAA;EACA,oDAAA;EACA,mEAAA;AAHF;AAKE;;EAEE,qCAAA;AAHJ;;AAOA,uGAAA;AACA,iHAAA;AACA;EACE,uCAAA;EACA,2BAAA;EACA,4BAAA;EACA,+BAAA;EACA,8BAAA;AAJF;;AAOA,sHAAA;AACA;EACE,uCAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,4BAAA;AAJF;;AAOA;EACE,yBAAA;AAJF;;AAOA,wHAAA;AACA;EACE,wBAAA;AAJF;;AAOA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;AAJF;;AAMA;EACE,uBAAA;AAHF;;AAKA;EACE,uBAAA;EACA,8BAAA;EACA,2BAAA;AAFF;;AAIA;EACE,YAAA;EACA,0BAAA;EACA,iCAAA;EACA,uBAAA;EACA,2BAAA;EACA,qBAAA;EACA,iCAAA;EACA,qCAAA;AADF;;AAGA;EACE,kBAAA;EACA,QAAA;AAAF;;AAEA;EACE,6BAAA;EACE,2BAAA;EACA,yBAAA;EACA,6BAAA;EACA,oDAAA;AACJ;;AAEA;EACE,WAAA;AACF;;AACA;EACE,0BC5XS;ED6XT,oDAAA;AAEF;;AAAA;EACG,UAAA;EACC,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,oDAAA;EACA,YAAA;EACA,YAAA;AAGJ;;AADA;EACI,0BC3YO;ED4YP,uBC1YQ;ED2YR,iBAAA;EACA,SAAA;EACA,OAAA;AAIJ;;AAFA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,4BAAA;EACA,cAAA;AAKF;;AAFA;EACE,4BAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAKF;;AAHA;EACE,wBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAMF;;AAHE;EACE,6BAAA;EACA,sBAAA;AAMJ;;AAHA;EACE,8BAAA;EACA,qBAAA;EACA,kCAAA;EACA,2BAAA;AAMF;;AAHA;EACE,sBAAA;AAMF;AALE;EACE,sBAAA;AAOJ;AANI;EACE,2BAAA;EACA,WAAA;AAQN;AALE;EACE,WAAA;EACA,YAAA;AAOJ;AANI;EACE,gCCjcM;EDkcN,oCClcM;AD0cZ;AANI;EACE,YAAA;AAQN;AALE;EACE,uBAAA;EACA,sBAAA;AAOJ;;AAHA,4EAAA;AACA;EACE,2BAAA;AAMF;AAJE;EACE,2BAAA;AAMJ;AAHE;EACE,qBAAA;EACA,+BAAA;AAKJ;AAFE;EACE,2BAAA;AAIJ;AADE;EACE,2BAAA;AAGJ;AAAE;EACE,qBAAA;AAEJ;;AAEA;EACE,8BAAA;EACA,oDAAA;AACF;;AACA;EACE,wBAAA;AAEF;;AAAA;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;AAGF;;AACA;EACE,0BAAA;EACA,gBAAA;AAEF;AADE;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;AAGJ;AACE;EACE,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;AACJ;;AAIA,qJAAA;AACA;;;;;;;;;;CAAA","sourcesContent":["@import '../../variables.scss';\r\n.search_field{\r\n  width: 70%;\r\n  height: 28px; padding-left: 2%;\r\n  float: left;\r\n\r\n}\r\n.search_field::placeholder{\r\n  font-size: 14px !important;\r\n}\r\n\r\n.mat-expansion-panel-header {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  padding: 0;\r\n  border-radius: inherit;\r\n}\r\n/* Restored original compact row height (as before / image 2). */\r\n::ng-deep.list_accordion .mat-expansion-panel-header {\r\n  height: 0px !important;\r\n}\r\n\r\n/* Single-line RuleName without widening the modal: title uses leftover row space; controls stay content-sized.\r\n   Material 16 renders mat-panel-title as .mat-expansion-panel-header-title (not .mat-panel-title). */\r\n::ng-deep.list_accordion .mat-expansion-panel-header .mat-content {\r\n  align-items: center;\r\n}\r\n::ng-deep.list_accordion .mat-expansion-panel-header-title {\r\n  flex: 1 1 auto !important;\r\n  max-width: none !important;\r\n  overflow: hidden;\r\n}\r\n::ng-deep.list_accordion .mat-expansion-panel-header-description {\r\n  /* Material default flex-grow: 2 left a large empty gap before Test Mode / toggle / Edit */\r\n  flex: 0 0 auto !important;\r\n  width: auto !important;\r\n  margin-right: 8px;\r\n  justify-content: flex-end;\r\n}\r\n::ng-deep.list_accordion .mat-expansion-panel-header-title .d-flex,\r\n::ng-deep.list_accordion .mat-expansion-panel-header-title strong {\r\n  white-space: nowrap;\r\n}\r\n\r\n::ng-deep.mat-expansion-indicator{\r\n  position: relative !important;\r\n  right: 1% !important;\r\n  top: -4px !important;\r\n}\r\n\r\n.filter_icon{\r\n  position: relative;top:7%;\r\n}\r\n\r\n.label_style{\r\n  display: block;\r\n  margin-block: 1%;\r\n  font-size: $fontsize;\r\n  overflow-y: auto !important;\r\n}\r\n\r\n.search_control_w700{\r\n  height:$inputHeight;\r\n  font-size:$fontsize;\r\n  box-shadow:0 2px 5px rgb(0 0 0 / 25%) !important;\r\n  border-radius: 5px;\r\n  overflow-y: auto !important;\r\n\r\n}\r\n.search_control_w700_input{\r\n  height:$inputHeight;\r\n  font-size:$fontsize;\r\n  box-shadow:0 2px 5px rgb(0 0 0 / 25%) !important;\r\n  border-radius: 5px;\r\n  overflow-y: auto !important;\r\n\r\n}\r\n// .search_control_w700_input::placeholder{\r\n//   color: black !important;\r\n//   font-weight: 700;\r\n// }\r\n\r\ninput::placeholder{\r\n  color: #797676 !important;\r\n}\r\n.w700_text{\r\n  font-size:$fontsize !important;\r\n}\r\n.varule-controls-wrap {\r\n  float: right;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  position: relative;\r\n  right: 3%;\r\n  top: 0px;\r\n  color: white;\r\n}\r\n\r\n.varule-toggle-anchor {\r\n  display: inline-flex;\r\n  align-items: center;\r\n}\r\n\r\n.varule-edit-btn {\r\n  background-color: rgb(23, 162, 184);\r\n  color: white;\r\n  border-radius: 4px;\r\n  padding-inline: 1%;\r\n  font-size: 15px;\r\n  margin: 3px;\r\n  border: none;\r\n  width: 35px;\r\n}\r\n\r\n.varule-reference-backdrop {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 10049;\r\n  background-color: rgba(0, 0, 0, 0.35);\r\n  pointer-events: auto;\r\n}\r\n\r\n.varule-reference-fixed-panel {\r\n  position: fixed;\r\n  z-index: 10050;\r\n  width: 335px;\r\n  max-width: 600px;\r\n  background: #fff;\r\n  border-radius: 4px;\r\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);\r\n  padding: 8px 12px 4px;\r\n}\r\n\r\n.varule-reference-field {\r\n  width: 100%;\r\n}\r\n\r\n.varule-reference-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 4px;\r\n  padding-bottom: 4px;\r\n}\r\n\r\n.disable-backdrop-click .cdk-overlay-backdrop.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing {\r\n  pointer-events: none;\r\n}\r\n::ng-deep.autocomplete-container .suggestions-container.is-visible {\r\n  z-index: 999 !important;\r\n}\r\n::ng-deep.autocomplete-container .suggestions-container {\r\n  position: absolute;\r\n  width: 100%;\r\n  background: #fff;\r\n  height: auto;\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%);\r\n  box-sizing: border-box;\r\n}\r\n\r\n::ng-deep.autocomplete-container .suggestions-container.is-visible {\r\n  visibility: visible;\r\n}\r\n\r\n::ng-deep.autocomplete-container .suggestions-container.is-visible {\r\n  z-index: 999 !important;\r\n}\r\n\r\n\r\n/* Scoped to VA Rules chip multiselect options only (.varules-multiselect-option) — avoids affecting other screens using .compendium_cast */\r\n.compendium_cast.varules-multiselect-option{\r\n  font-family: Roboto, \"Helvetica Neue\", Helvetica, Arial, sans-serif !important;\r\n  height: 30px!important;\r\n\r\n  .multiselect-suggestion-row {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .varules-ms-chosen-mark {\r\n    flex-shrink: 0;\r\n    min-width: 1.1em;\r\n    margin-right: 4px;\r\n    font-weight: 700;\r\n    font-size: 12px;\r\n    line-height: 1;\r\n  }\r\n\r\n  .multiselect-suggestion-em {\r\n    font-weight: 700 !important;\r\n    font-style: normal !important;\r\n  }\r\n}\r\n\r\n/* Panel is in CDK overlay — pierce encapsulation; selector includes .varules-multiselect-option so Compendium/Homepage .compendium_cast options are untouched */\r\n::ng-deep .cdk-overlay-container .mat-mdc-option.varules-multiselect-option .multiselect-suggestion-em {\r\n  font-weight: 700 !important;\r\n  font-family: Roboto, \"Helvetica Neue\", Helvetica, Arial, sans-serif !important;\r\n}\r\n::ng-deep .cdk-overlay-container .mat-mdc-option.varules-multiselect-option .mdc-list-item__primary-text strong.multiselect-suggestion-em {\r\n  font-weight: 700 !important;\r\n  font-family: Roboto, \"Helvetica Neue\", Helvetica, Arial, sans-serif !important;\r\n}\r\n::ng-deep .cdk-overlay-container .mat-mdc-option.varules-multiselect-option.compendium_cast .mdc-list-item__primary-text {\r\n  font-family: Roboto, \"Helvetica Neue\", Helvetica, Arial, sans-serif !important;\r\n}\r\n\r\n/* ADDITIVE: chip mat-autocomplete (Case Status + API chip multiselects e.g. Excluded OF Accounts) — scrollable panel; host uses `[class]` (not panelClass) so overlay gets this class; pane z-index above ngx .autocomplete-container.active (10001) in this file. */\r\n::ng-deep body .cdk-overlay-pane:has(.varules-chip-mat-scroll-panel) {\r\n  z-index: 10100 !important;\r\n}\r\n\r\n::ng-deep .cdk-overlay-container .mat-mdc-autocomplete-panel.varules-chip-mat-scroll-panel {\r\n  max-height: min(50vh, 320px) !important;\r\n  min-height: 0 !important;\r\n  overflow-y: auto !important;\r\n  overflow-x: hidden !important;\r\n  pointer-events: auto !important;\r\n  touch-action: auto !important;\r\n}\r\n\r\n::ng-deep .cdk-overlay-container .mat-mdc-autocomplete-panel.varules-chip-mat-scroll-panel.mdc-menu-surface {\r\n  min-height: 0 !important;\r\n  overflow-y: auto !important;\r\n}\r\n\r\n/* Case Status chip panel only: label + ✓ on the right; chosen rows stay visible with teal text/bg (full list or filtered). */\r\n/* was: ✓ color #17a2b8, margin-right 6px — not flush to row edge, not purple. */\r\n::ng-deep .cdk-overlay-container .mat-mdc-autocomplete-panel.varules-casestatus-only-chip-panel {\r\n  /* Let the custom row span the option’s content width so ✓ can sit at the trailing edge. */\r\n  .mat-mdc-option.compendium_cast.varules-multiselect-option .mat-mdc-option-text,\r\n  .mat-mdc-option.compendium_cast.varules-multiselect-option .mdc-list-item__primary-text {\r\n    width: 100%;\r\n    max-width: 100%;\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  .varules-case-status-suggestion-row.multiselect-suggestion-row {\r\n    display: flex;\r\n    width: 100%;\r\n    min-width: 0;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  .varules-case-status-suggestion-row .multiselect-suggestion-label {\r\n    flex: 1 1 auto;\r\n    min-width: 0;\r\n    padding-right: 4px;\r\n  }\r\n\r\n  /* was: color #7b1fa2 without !important — MDC / theme could still paint the ✓ like body text. */\r\n  .varules-case-status-suggestion-row .varules-ms-chosen-mark--casestatus-end {\r\n    flex: 0 0 auto;\r\n    margin-left: auto;\r\n    /* was: margin-right 0 — align ✓ with the visual right edge of the list row (MDC option padding). */\r\n    margin-right: -10px;\r\n    padding-right: 12px;\r\n    min-width: 1.1em;\r\n    text-align: right;\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 1;\r\n    color: #9c27b0 !important;\r\n    -webkit-text-fill-color: #9c27b0 !important;\r\n  }\r\n\r\n  .mat-mdc-option.varules-case-status-option-chosen .varules-ms-chosen-mark--casestatus-end {\r\n    color: #9c27b0 !important;\r\n    -webkit-text-fill-color: #9c27b0 !important;\r\n  }\r\n\r\n  .mat-mdc-option.varules-case-status-option-chosen {\r\n    background-color: rgba(23, 162, 184, 0.14) !important;\r\n  }\r\n\r\n  .mat-mdc-option.varules-case-status-option-chosen.mat-mdc-option-active {\r\n    background-color: rgba(23, 162, 184, 0.22) !important;\r\n  }\r\n\r\n  .mat-mdc-option.varules-case-status-option-chosen .multiselect-suggestion-label,\r\n  .mat-mdc-option.varules-case-status-option-chosen .multiselect-suggestion-label strong.multiselect-suggestion-em {\r\n    color: #0f6674 !important;\r\n    font-weight: 600 !important;\r\n  }\r\n}\r\n\r\n/* Case Status + empty filter: was blanket black on all options — hid chosen highlight. Now only strip stray MDC accent on rows that are not chip-chosen. */\r\n/* was:\r\n::ng-deep .cdk-overlay-container .mat-mdc-autocomplete-panel.varules-casestatus-only-chip-panel.varules-casestatus-autocomplete-empty-query {\r\n  .mat-mdc-option,\r\n  .mat-mdc-option .mdc-list-item__primary-text,\r\n  ...\r\n}\r\n*/\r\n::ng-deep .cdk-overlay-container .mat-mdc-autocomplete-panel.varules-casestatus-only-chip-panel.varules-casestatus-autocomplete-empty-query {\r\n  --mat-option-selected-state-label-text-color: rgba(0, 0, 0, 0.87);\r\n  --mat-option-selected-state-layer-color: transparent;\r\n  --mat-full-pseudo-checkbox-selected-icon-color: rgba(0, 0, 0, 0.54);\r\n\r\n  .mat-mdc-option:not(.varules-case-status-option-chosen).mat-mdc-option-active .mdc-list-item__primary-text,\r\n  .mat-mdc-option:not(.varules-case-status-option-chosen).mdc-list-item--selected .mdc-list-item__primary-text {\r\n    color: rgba(0, 0, 0, 0.87) !important;\r\n  }\r\n}\r\n\r\n/* ngx-auto-complete dropdown (LabUIControls / Lab Integration / Additional data): scroll suggestions */\r\n/* .autocomplete-container .suggestions-container — height: auto only; limit height so wheel/touch scroll works */\r\n::ng-deep .varules-ng-autocomplete-options-scroll .autocomplete-container .suggestions-container {\r\n  max-height: min(50vh, 320px) !important;\r\n  overflow-y: auto !important;\r\n  overscroll-behavior: contain;\r\n  pointer-events: auto !important;\r\n  touch-action: pan-y !important;\r\n}\r\n\r\n/* ngx-autocomplete often scrolls the inner ul; modal stacking can trap/hide dropdown — explicit ul scroll + z-index */\r\n::ng-deep .varules-ng-autocomplete-options-scroll .autocomplete-container .suggestions-container ul {\r\n  max-height: min(45vh, 260px) !important;\r\n  overflow-y: auto !important;\r\n  -webkit-overflow-scrolling: touch;\r\n  touch-action: pan-y !important;\r\n  overscroll-behavior: contain;\r\n}\r\n\r\n::ng-deep .varules-ng-autocomplete-options-scroll .autocomplete-container.active {\r\n  z-index: 10001 !important;\r\n}\r\n\r\n/* Bootstrap modal (~1050) is above default CDK overlay (~1000) — MatAutocomplete panel could not receive wheel events */\r\n::ng-deep body .cdk-overlay-container {\r\n  z-index: 1060 !important;\r\n}\r\n\r\n::ng-deep.compendium_casetype .mat-standard-chip{\r\n  font-size: 11px;\r\n  margin: 0px;\r\n  height: 23px;\r\n  padding-inline: 5px;\r\n  min-height:unset;\r\n}\r\n::ng-deep.compendium_casetype .mat-form-field-wrapper{\r\n  padding: 0px !important;\r\n}\r\n::ng-deep.compendium_casetype  .mat-form-field-infix{\r\n  padding: 4px !important;\r\n  padding-bottom: 6px !important;\r\n  padding-top: 0px !important;\r\n}\r\n.chipinput{\r\n  height: 16px;\r\n  font-size: 11px !important;\r\n  box-sizing: border-box !important;\r\n  border: none !important;\r\n  box-shadow: none!important;\r\n  outline: 0 !important;\r\n  background-color: #fff !important;\r\n  color: rgba(0, 0, 0, 0.87) !important;\r\n}\r\n.checkbox{\r\n  position: relative;\r\n  top:40%;\r\n}\r\n.mat-form-field{\r\n  position: relative!important;\r\n    text-align: left!important;;\r\n    display: block!important;;\r\n    border-radius: 5px!important;\r\n    box-shadow: 0 2px 5px rgb(0 0 0 / 25%) !important;\r\n\r\n}\r\n::ng-deep.varules .mat-form-field-appearance-outline .mat-form-field-flex {\r\n  padding: 0%;\r\n}\r\n.varule_textarea{\r\n  font-size:$fontsize;\r\n  box-shadow:0 2px 5px rgb(0 0 0 / 25%) !important;\r\n}\r\n.addvarule{\r\n   width: 50%;\r\n    background-color: white;\r\n    text-align: center;\r\n    position: relative;\r\n    top: 10%;\r\n    border-radius: 5px;\r\n    box-shadow:0 2px 5px rgb(0 0 0 / 25%) !important;\r\n    float: right;\r\n    height: 29px;\r\n}\r\n.addvarulebtn{\r\n    font-size: $fontsize;\r\n    height: $btnHeight;\r\n    line-height: 20px;\r\n    right: 1%;\r\n    top: 0%;\r\n}\r\n.ellipsisfull{\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  /* width: 100% !important; */\r\n  max-width: 90%;\r\n}\r\n\r\n::ng-deep.varules .row {\r\n  display: contents !important;\r\n  flex-wrap: unset;\r\n  margin-right: -15px;\r\n  margin-left: -15px;\r\n}\r\n::ng-deep.list_accordion .row {\r\n  display: flex !important;\r\n  flex-wrap: unset;\r\n  margin-right: -15px;\r\n  margin-left: -15px;\r\n  font-size: 12px;\r\n}\r\n::ng-deep.testmodecheckbox{\r\n  .mdc-checkbox{\r\n    padding-right: 3px !important;\r\n    bottom: 3px !important;\r\n  }\r\n}\r\n.text-ellipsis {\r\n  white-space: nowrap !important;\r\n  width: 40% !important;\r\n  text-overflow: ellipsis !important;\r\n  overflow: hidden !important;\r\n}\r\n\r\n::ng-deep.varulecheckox.mat-mdc-checkbox {\r\n  width: 100% !important;\r\n  .mdc-form-field{\r\n    width: 100% !important;\r\n    .mdc-label{\r\n      margin-bottom: 0 !important;\r\n      width: 100%;\r\n    }\r\n  }\r\n  .mdc-checkbox {\r\n    width: 16px;\r\n    height: 16px;\r\n    .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background{\r\n      border-color: $btn-color;\r\n      background-color: $btn-color;\r\n    }\r\n    .mdc-checkbox__native-control:enabled~.mdc-checkbox__background .mdc-checkbox__checkmark {\r\n      color: white;\r\n  }\r\n  }\r\n  .mdc-checkbox__background{\r\n    height: 16px !important;\r\n    width: 16px !important;\r\n  }\r\n}\r\n\r\n/* Test Mode checkbox: strip shadow/ripple halo (used with .varulecheckox) */\r\n::ng-deep.test-mode-checkbox-no-shadow.mat-mdc-checkbox {\r\n  box-shadow: none !important;\r\n\r\n  .mdc-checkbox {\r\n    box-shadow: none !important;\r\n  }\r\n\r\n  .mdc-checkbox__ripple {\r\n    opacity: 0 !important;\r\n    pointer-events: none !important;\r\n  }\r\n\r\n  .mat-mdc-checkbox-touch-target {\r\n    box-shadow: none !important;\r\n  }\r\n\r\n  .mat-focus-indicator::before {\r\n    box-shadow: none !important;\r\n  }\r\n\r\n  .mdc-checkbox__native-control:focus-visible ~ .mdc-checkbox__ripple {\r\n    opacity: 0 !important;\r\n  }\r\n}\r\n\r\n.borderstyles{\r\n  border: transparent !important;\r\n  box-shadow:0 2px 5px rgb(0 0 0 / 25%) !important;\r\n}\r\n:ng-deep.mat-mdc-form-field-subscript-wrapper{\r\n  display: none !important;\r\n}\r\n::ng-deep.myCustomModalClassaddvarule .modal-dialog {\r\n  max-width: 97%;\r\n  max-height: 60%;\r\n  height: 60%;\r\n  margin: auto;\r\n  padding: 0 !important;\r\n}\r\n\r\n::ng-deep.matchipstyles{\r\n.mat-mdc-chip-row {\r\n  max-width: 20vw !important;\r\n  overflow: hidden;\r\n  .mdc-evolution-chip__text-label {\r\n    max-width: 100%;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    display: inline-block;\r\n  }\r\n  \r\n  // Fallback for older Material chip structure\r\n  > span:not(mat-icon) {\r\n    max-width: calc(100% - 24px);\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    display: inline-block;\r\n  }\r\n}\r\n}\r\n\r\n/* REVERTED: inner scroll wrapper (.varules-edit-modal-body / .varules-edit-modal-body-scroll) — HTML reverted to single modal-body overflow-y:auto */\r\n/*\r\n::ng-deep .myCustomModalClassaddvarule .modal-body.varules-edit-modal-body {\r\n  overflow: visible !important;\r\n}\r\n.varules-edit-modal-body-scroll {\r\n  max-height: min(calc(100vh - 220px), 720px);\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n  overscroll-behavior: contain;\r\n}\r\n*/","$btn-color: #17a0b4 !important;\r\n$fontsize: 12px !important;\r\n$btntextcolor: white !important;\r\n$btnHeight: 28px !important;\r\n$inputHeight:30px !important;\r\n$inputfontsize:11px !important;\r\n$primary:#004bff;\r\n// $modalHeaderTitleFont: ;\r\n@mixin modalheaderTtext {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
